module.exports = "/fonts/nucleo-icons.svg?01ebecaf50461162d4bce4c5908672b5";